import { useState } from "react";
import { useLogin } from "../hooks/useLogin";
import { useForm } from "react-hook-form";
import { EyeSlashIcon, EyeIcon } from "@heroicons/react/24/outline";
type FormValues = {
  username: string;
  password: string;
};

export function LoginComponent() {
  const { loginMutation } = useLogin();
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = async (data: { username: string; password: string }) => {
    try {
      await loginMutation.mutateAsync({
        username: data.username,
        password: data.password,
      });
    } catch {
      setError("password", {
        type: "custom",
        message:
          "The email and password you entered do not match our system's records. Please double-check and try again. If you’ve forgotten your password, contact us for assistance.",
      });
    }
  };

  return (
    <div className="bg-slate-50 h-screen w-screen flex items-center justify-center font-[ABeeZee]">
      <div className="bg-slate-100 p-10 w-full md:w-1/3 m-4 rounded-md shadow-xl shadow-slate-300">
        <h2 className="text-xl pb-4">Sign In</h2>
        <form
          className="flex flex-col space-y-10"
          onSubmit={handleSubmit(onSubmit)}
        >
          <input
            className="rounded-md p-4 w-full"
            type="username"
            placeholder="Username"
            {...register("username", { required: true, maxLength: 80 })}
          />
          <div className="relative w-full">
            <input
              className="rounded-md p-4 w-full"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              {...register("password", { required: true })}
            />{" "}
            <button
              type="button"
              className="absolute inset-y-0 right-3 flex items-center m-0 p-2"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? (
                <EyeSlashIcon className="h-full" />
              ) : (
                <EyeIcon className="h-full" />
              )}
            </button>
          </div>
          {errors.password && (
            <span className="text-red-500">{errors.password.message}</span>
          )}
          {
            <input
              type="submit"
              value="Log In"
              className="bg-gray-900 hover:bg-gray-700 cursor-pointer p-4 rounded-md disabled:bg-slate-200 text-white"
              disabled={loginMutation.isPending}
            />
          }
        </form>
      </div>
    </div>
  );
}
